/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ActionInputs */

const id_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksi`)
};

const ms_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksi`)
};

const da_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const en_us2_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const es_es2_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const es_mx2_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const fil_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksyon`)
};

const fr_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const it_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione`)
};

const hu_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akció`)
};

const nl_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actie`)
};

const no_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const pl_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akcja`)
};

const pt_br2_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação`)
};

const pt_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação`)
};

const ro_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acțiune`)
};

const fi_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toiminta`)
};

const sv_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const vi_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hành động`)
};

const tr_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksiyon`)
};

const cs_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akční`)
};

const bg_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Екшън`)
};

const ru_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экшн`)
};

const uk_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Екшн`)
};

const ar_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكشن`)
};

const hi_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक्शन`)
};

const th_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอ็กชัน`)
};

const ja_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクション`)
};

const zh_cn2_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动作`)
};

const zh_hant1_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動作`)
};

const ko_nav_action = /** @type {(inputs: Nav_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`액션`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Nav_ActionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_action = /** @type {((inputs?: Nav_ActionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ActionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_action(inputs)
	if (locale === "ms") return ms_nav_action(inputs)
	if (locale === "da") return da_nav_action(inputs)
	if (locale === "de") return de_nav_action(inputs)
	if (locale === "en-US") return en_us2_nav_action(inputs)
	if (locale === "es-ES") return es_es2_nav_action(inputs)
	if (locale === "es-MX") return es_mx2_nav_action(inputs)
	if (locale === "fil") return fil_nav_action(inputs)
	if (locale === "fr") return fr_nav_action(inputs)
	if (locale === "it") return it_nav_action(inputs)
	if (locale === "hu") return hu_nav_action(inputs)
	if (locale === "nl") return nl_nav_action(inputs)
	if (locale === "no") return no_nav_action(inputs)
	if (locale === "pl") return pl_nav_action(inputs)
	if (locale === "pt-BR") return pt_br2_nav_action(inputs)
	if (locale === "pt") return pt_nav_action(inputs)
	if (locale === "ro") return ro_nav_action(inputs)
	if (locale === "fi") return fi_nav_action(inputs)
	if (locale === "sv") return sv_nav_action(inputs)
	if (locale === "vi") return vi_nav_action(inputs)
	if (locale === "tr") return tr_nav_action(inputs)
	if (locale === "cs") return cs_nav_action(inputs)
	if (locale === "bg") return bg_nav_action(inputs)
	if (locale === "ru") return ru_nav_action(inputs)
	if (locale === "uk") return uk_nav_action(inputs)
	if (locale === "ar") return ar_nav_action(inputs)
	if (locale === "hi") return hi_nav_action(inputs)
	if (locale === "th") return th_nav_action(inputs)
	if (locale === "ja") return ja_nav_action(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_action(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_action(inputs)
	return ko_nav_action(inputs)
});
export { nav_action as "nav.action" }